import React, { useState, useEffect } from 'react';
import './Testimonial.css';

function Testimonial() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const testimonials = [
    {
     
      text: '“The care I received at Fatima Hospital & Diagnostic Centre was exceptional. The staff were professional and compassionate, and the facilities were top-notch.”',
      author: 'Racheal Woods'
    },
    {
      text: 'I highly recommend Fatima Hospital & Diagnostic Centre for their diagnostic services. The results were fast and accurate, and the staff explained everything clearly.”',
      author: 'Diana Stooge'
    },
    {
      
      text: '“From the moment I walked in, I felt at ease. The doctors took the time to listen to my concerns and provided excellent care.”',
      author: 'Barry White'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((currentSlide + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide, testimonials.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className='testimonial'>
      <h2>Patient Testimonials</h2>
     
       <div className='test-con'>
          <div className='test-left'>
          <div className='slider'>
            <div className='slides'>
            {testimonials.map((testimonial, index) => (
                <div className='slide' key={index} style={{ display: index === currentSlide ? 'block' : 'none' }}>
                <div className='test-box'>
                    <p>{testimonial.text}</p>
                    <span>{testimonial.author}</span>
                </div>
                </div>
            ))}
            </div>
         </div>
         <div className='dots'>
            {testimonials.map((_, index) => (
            <span
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
            ></span>
            ))}
          </div>

          </div>

          <div className='test-right'>
            <img src='https://res.cloudinary.com/dxnukbo0u/image/upload/v1721714659/2148525067_jvge0e.jpg' alt=''></img>
          </div>
       </div>
    </div>
  );
}

export default Testimonial;
